import { useSelector } from 'react-redux';
import { call, put, takeLatest } from 'redux-saga/effects';
import {
  CASE_GET_TEAM_ACTIVITY_LOGS_BEGIN,
  CASE_GET_TEAM_ACTIVITY_LOGS_SUCCESS,
  CASE_GET_TEAM_ACTIVITY_LOGS_FAILURE,
  CASE_GET_TEAM_ACTIVITY_LOGS_DISMISS_FEEDBACK,
} from './constants';
import {
  createPromiseAction,
  resolvePromiseAction,
  rejectPromiseAction,
} from '@adobe/redux-saga-promise';
import api from 'common/api';
import { withCurrentCaseId } from '../../../common/selectors';

export const getTeamActivityLogs = createPromiseAction(CASE_GET_TEAM_ACTIVITY_LOGS_BEGIN);

export function dismissGetTeamActivityLogs() {
  return {
    type: CASE_GET_TEAM_ACTIVITY_LOGS_DISMISS_FEEDBACK,
  };
}

export function* doGetTeamActivityLogs(action) {
  const { caseId, teamId } = action.payload;

  let res = yield call(api.get, `/cases/${caseId}/teams/${teamId}/logs`);

  if (res && res.error) {
    yield put({
      type: CASE_GET_TEAM_ACTIVITY_LOGS_FAILURE,
      feedback: {
        message: 'feedback.getMoreInfoDocumentFailure',
        error: res.error,
        retryAction: action,
      },
    });
    return yield call(rejectPromiseAction, action, res.error);
  }

  yield put({
    type: CASE_GET_TEAM_ACTIVITY_LOGS_SUCCESS,
    data: { teamActivityLogs: res },
  });
  yield call(resolvePromiseAction, action, res);
}

export function* watchGetTeamActivityLogs() {
  yield takeLatest(getTeamActivityLogs, withCurrentCaseId(doGetTeamActivityLogs));
}

export function reducer(state, action) {
  switch (action.type) {
    case CASE_GET_TEAM_ACTIVITY_LOGS_BEGIN + '.TRIGGER':
      // Just after a request is sent
      return {
        ...state,
        getTeamActivityLogsPending: true,
        getTeamActivityLogsFeedback: null,
      };

    case CASE_GET_TEAM_ACTIVITY_LOGS_SUCCESS:
      // The request is success
      return {
        ...state,
        getTeamActivityLogsPending: false,
        getTeamActivityLogsFeedback: action.feedback,
        teamActivityLogs: action.data.teamActivityLogs,
      };

    case CASE_GET_TEAM_ACTIVITY_LOGS_FAILURE:
      // The request is failed
      return {
        ...state,
        getTeamActivityLogsPending: false,
        getTeamActivityLogsFeedback: action.feedback,
      };

    case CASE_GET_TEAM_ACTIVITY_LOGS_DISMISS_FEEDBACK:
      // Dismiss the request failure Feedback
      return {
        ...state,
        getTeamActivityLogsFeedback: null,
      };

    default:
      return state;
  }
}
